import React, { useState, useRef, useEffect } from "react";
import MetaTags from "react-meta-tags";
import { Row, Col, CardBody, Card, Alert, Container, Input, Label, Form, FormFeedback } from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import ApiClient from "../../FindagramAdmin/BaseUrl/ApiClient";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { apiError } from "../../store/actions";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";


import bitelogo from "../../assets/images/bitelogo.png";

const Login = (props) => {
    const dispatch = useDispatch();
    const [errorMsg, setErrorMsg] = useState(null);
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const isMounted = useRef(true);
    const API_URL = process.env.REACT_APP_BASE_URL || "";

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    const validationSchema = Yup.object({
        email: Yup.string()
            .email("Invalid email format")
            .required("Please enter your email"),
        password: Yup.string()
            .min(8, "Password must be at least 8 characters")
            .required("Please enter your password"),
    });

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: "",
            password: "",
        },
        validationSchema,
        onSubmit: async (values) => {
            setLoading(true);
            ApiClient()
                .post("/auth/admin/login", values)
                .then((response) => {
                    const { responseData } = response.data;
                    const { accessToken, refreshToken, user } = responseData.data;



                    localStorage.setItem("accessToken", accessToken);
                    localStorage.setItem("refreshToken", refreshToken);
                    localStorage.setItem("authUser", JSON.stringify(user));

                    toast.success("Admin successfully logged in!");

                    setTimeout(() => {

                        props.history.push("/business-list");
                    }, 1500);
                })
                .catch((error) => {
                    let errorMessage = "Login failed";

                    if (error.response) {

                        if (error.response.data && error.response.data.responseMessage) {
                            errorMessage = Array.isArray(error.response.data.responseMessage)
                                ? error.response.data.responseMessage.join(', ')
                                : error.response.data.responseMessage;
                        } else if (error.response.status === 401) {
                            errorMessage = "Invalid credentials";
                        }
                    } else if (error.message) {
                        errorMessage = error.message;
                    }

                    toast.error(errorMessage);
                })
                .finally(() => {
                    setLoading(false);
                });
        },
    });

    const { registrationError } = useSelector((state) => ({
        registrationError: state.Account.registrationError,
    }));

    useEffect(() => {
        dispatch(apiError(""));
        return () => {
            isMounted.current = false;
        };
    }, [dispatch]);

    return (
        <React.Fragment>
            <ParticlesAuth>
                <div className="auth-page-content">
                    <MetaTags>
                        <title>Admin Login | BiteSaver</title>
                    </MetaTags>
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center text-white-50">
                                    <div>
                                        <Link to="/" className="d-inline-block auth-logo">
                                            <img src={bitelogo} alt="BiteSaver Logo" height="150" />
                                        </Link>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <Card className="mt-4">
                                    <CardBody className="p-4">
                                        <div className="text-center mt-2">
                                            <h5 className="text-primary">Admin Panel!</h5>
                                            <p className="text-muted">Please enter your details to sign in.</p>
                                        </div>
                                        <div className="p-2 mt-4">
                                            <Form
                                                onSubmit={(e) => {
                                                    e.preventDefault();
                                                    validation.handleSubmit();
                                                    return false;
                                                }}
                                                className="needs-validation"
                                                action="#"
                                            >
                                                {registrationError && registrationError ? (
                                                    <Alert color="danger">
                                                        <div>{registrationError}</div>
                                                    </Alert>
                                                ) : null}

                                                <div className="mb-3">
                                                    <Label htmlFor="email" className="form-label">
                                                        Email <span className="text-danger">*</span>
                                                    </Label>
                                                    <Input
                                                        id="email"
                                                        name="email"
                                                        className="form-control"
                                                        placeholder="Enter email address"
                                                        type="email"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.email || ""}
                                                        invalid={validation.touched.email && validation.errors.email}
                                                    />
                                                    {validation.touched.email && validation.errors.email ? (
                                                        <FormFeedback type="invalid">
                                                            <div>{validation.errors.email}</div>
                                                        </FormFeedback>
                                                    ) : null}
                                                </div>

                                                <div className="mb-3">
                                                    <Label htmlFor="password" className="form-label">
                                                        Password <span className="text-danger">*</span>
                                                    </Label>
                                                    <div style={{ position: "relative" }}>
                                                        <Input
                                                            id="password"
                                                            name="password"
                                                            className="form-control"
                                                            placeholder="Enter password"
                                                            type={showPassword ? "text" : "password"}
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.password || ""}
                                                            invalid={!!(validation.touched.password && validation.errors.password)} // Ensure invalid is boolean
                                                        />
                                                        <button
                                                            type="button"
                                                            className="position-absolute top-50 translate-middle-y pe-3 border-0 bg-transparent"
                                                            onClick={togglePasswordVisibility}
                                                            style={{
                                                                right: "15px",
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            <i className={showPassword ? "ri-eye-off-line" : "ri-eye-line"}></i>
                                                        </button>
                                                    </div>
                                                    {validation.touched.password && validation.errors.password ? (
                                                        <FormFeedback style={{ display: "block" }}>
                                                            {validation.errors.password}
                                                        </FormFeedback>
                                                    ) : null}
                                                </div>

                                                <div className="mb-3 text-end">
                                                    <Link to="/forgot-password" className="text-muted">
                                                        Forgot Password?
                                                    </Link>
                                                </div>

                                                <div className="mt-4">
                                                    <button
                                                        className="btn btn-success w-100"
                                                        type="submit"
                                                        disabled={loading}
                                                    >
                                                        {loading ? (
                                                            <>
                                                                <span
                                                                    className="spinner-border spinner-border-sm me-2"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                ></span>
                                                                Signing In...
                                                            </>
                                                        ) : (
                                                            "Sign In"
                                                        )}
                                                    </button>
                                                </div>




                                            </Form>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </ParticlesAuth>
            <ToastContainer />
        </React.Fragment>
    );
};

export default Login;